export default __webpack_public_path__ + "static/media/mainIntro.68b3888b.mp4";